import amex from "public/images/credit_card/card_amex.png";
import jcb from "public/images/credit_card/card_jcb.png";
import mastercard from "public/images/credit_card/card_mastercard.png";
import visa from "public/images/credit_card/card_visa.png";

export const CREDIT_CARD_TYPE = {
  AMEX: 1,
  JCB: 2,
  VISA: 3,
  MASTER_CARD: 4,
  OTHER: 5,
} as const;

export type CreditCardType = ValueOf<typeof CREDIT_CARD_TYPE>;

type CreditCardBrandLogo =
  | typeof visa
  | typeof amex
  | typeof jcb
  | typeof mastercard
  | undefined;

export type CreditCardBrandLogoSize = Readonly<{
  width: number;
  height: number;
}>;

export const CreditCardBrandLogoSize: {
  [key in CreditCardType]: CreditCardBrandLogoSize;
} = {
  [CREDIT_CARD_TYPE.AMEX]: { width: 28, height: 28 } as const,
  [CREDIT_CARD_TYPE.JCB]: { width: 28, height: 22 } as const,
  [CREDIT_CARD_TYPE.VISA]: { width: 40, height: 13 } as const,
  [CREDIT_CARD_TYPE.MASTER_CARD]: { width: 32, height: 29 } as const,
  [CREDIT_CARD_TYPE.OTHER]: { width: 29, height: 15 } as const,
};

const getTextByCreditCardType = (cardCompany: CreditCardType) => {
  switch (cardCompany) {
    case CREDIT_CARD_TYPE.AMEX:
      return "Amex";
    case CREDIT_CARD_TYPE.JCB:
      return "JCB";
    case CREDIT_CARD_TYPE.MASTER_CARD:
      return "MasterCard";
    case CREDIT_CARD_TYPE.VISA:
      return "Visa";
    default:
      return "その他";
  }
};

const getCreditCardBrandLogo = (type: CreditCardType): CreditCardBrandLogo => {
  switch (type) {
    case CREDIT_CARD_TYPE.AMEX:
      return amex;
    case CREDIT_CARD_TYPE.JCB:
      return jcb;
    case CREDIT_CARD_TYPE.MASTER_CARD:
      return mastercard;
    case CREDIT_CARD_TYPE.VISA:
      return visa;
    default:
  }
};

export const CreditCardType = {
  getTextByCreditCardType,
  getCreditCardBrandLogo,
} as const;
